import { ChangeDetectionStrategy, Component } from "@angular/core";

/**
 * Responsive card grid wrapper using CSS Container Queries.
 * Responds to the container (panel) width, not the viewport:
 * - < 560px (bubble ~420px, toolbar ~350px) → 1 column
 * - ≥ 560px (full-screen panel) → 2 columns
 */
@Component({
  selector: "app-card-grid",
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<div class="card-grid"><ng-content /></div>`,
  styleUrl: "./card-grid.component.scss",
})
export class CardGridComponent {}
